export default __webpack_public_path__ + "static/media/sanmar19.0873ab66.jpg";